export const DEMANDE_INTERVENTION = {
    SET_ITEMS: 'SET_DEMANDE_INTERVENTION_ITEMS',
    RESET_ITEMS: 'RESET_DEMANDE_INTERVENTION_ITEMS',
    ADD_ITEMS: 'ADD_DEMANDE_INTERVENTION_ITEMS',
    SET_ITEM: 'SET_DEMANDE_INTERVENTION_ITEM',

    SET_PAGE: 'SET_DEMANDE_INTERVENTION_PAGE',
    REMOVE_ITEM: 'REMOVE_DEMANDE_INTERVENTION_ITEM',
    SET_NB_OF_PAGES: 'SET_DEMANDE_INTERVENTION_NB_OF_PAGES',
    SET_SCROLL: 'SET_DEMANDE_INTERVENTION_SCROLL',

    SET_SORT: 'SET_DEMANDE_INTERVENTION_SORT',
    SET_FILTER_STATUS: 'DEMANDE_INTERVENTION_SET_FILTER_STATUS',
    RESET_FILTER: 'DEMANDE_INTERVENTION_RESET_FILTER',
    SET_FILTER_DEMANDE_INTERVENTION_ID: 'DEMANDE_INTERVENTION_SET_FILTER_DEMANDE_INTERVENTION_ID',
    SET_FILTER_ONLY_MINE: 'DEMANDE_INTERVENTION_SET_FILTER_ONLY_MINE',
    ADD_FILTER_SITE: 'DEMANDE_INTERVENTION_ADD_FILTER_SITE',
    REMOVE_FILTER_SITE: 'DEMANDE_INTERVENTION_REMOVE_FILTER_SITE',
    SET_FILTER_SITE: 'DEMANDE_INTERVENTION_SET_FILTER_SITE',
    SET_FILTER_SITE_IDS: 'SET_FILTER_SITE_IDS',

    ADD_FILTER_STATUS: 'DEMANDE_INTERVENTION_ADD_FILTER_STATUS',
    REMOVE_FILTER_STATUS: 'DEMANDE_INTERVENTION_REMOVE_FILTER_STATUS',
    SET_COUNT: 'DEMANDE_INTERVENTION_SET_COUNT',
    SET_FILTER_CREATED_DATE_FROM: 'DEMANDE_INTERVENTION_SET_FILTER_CREATED_DATE_FROM',
    SET_FILTER_CREATED_DATE_TO: 'DEMANDE_INTERVENTION_SET_FILTER_CREATED_DATE_TO',

    SET_IS_LOADING: 'SET_DEMANDE_INTERVENTION_IS_LOADING',
    SET_ERROR: 'SET_DEMANDE_INTERVENTION_ERROR',

    SET_ATTACHMENT: 'SET_ATTACHMENT',
    SET_ATTACHMENT_TYPE: 'SET_ATTACHMENT_TYPE',
    SET_ATTACHMENT_LOADING: 'SET_ATTACHMENT_LOADING',

    CLEAR_ALL: 'DEMANDE_INTERVENTION_CLEAR_ALL',

    SET_EXPORT_XLS_IS_LOADING: 'SET_SUIVI_DEMANDE_INTERVENTION_EXPORT_XLS_IS_LOADING',
};
